import { useCallback, useEffect, useState } from 'react';

export const useVisibilityAwareInterval = (callback: () => void, delay: number): void => {
  const [isVisible, setIsVisible] = useState(document.visibilityState === 'visible');

  const handleVisibilityChange = useCallback(() => {
    setIsVisible(document.visibilityState === 'visible');
  }, []);

  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);

    let interval: ReturnType<typeof setInterval> | null = null;

    if (isVisible) {
      interval = setInterval(callback, delay);
    }

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isVisible, handleVisibilityChange, callback, delay]);
};
